import React, { Component } from 'react'
import LoaderButton from '../LoaderButton'
import FormViewer from '../FormViewer'
import Collapsible from 'react-collapsible'
export default class FirstStep extends Component {
    state = {
        today: [
            {
                day: 'شنبه',
                cot: '19 آذر'
            },
            {
                day: 'یکشنبه',
                cot: '20 آذر'
            },
            {
                day: 'دوشنبه',
                cot: '21 آذر'
            },
            {
                day: 'سه شنبه',
                cot: '22 آذر'
            },
            {
                day: 'چهار شنبه',
                cot: '23 آذر'
            },
            {
                day: 'پنجشنبه',
                cot: '24 آذر'
            },
            {
                day: 'جمعه',
                cot: '25 آذر'
            },
        ],
        book: [
            {
                img: '/images/male.png',
                name: 'test',
                dec: 'test test test test test',
                prc: '20',
                time: [
                    {
                        time: '8:30',
                    },
                    {
                        time: '9:30',
                    },
                    {
                        time: '10:30',
                    },
                    {
                        time: '11:30',
                    },
                    {
                        time: '12:30',
                    },
                    {
                        time: '13:30',
                    },
                    {
                        time: '14:30',
                    },
                    {
                        time: '14:30',
                    },
                    {
                        time: '14:30',
                    },
                    {
                        time: '14:30',
                    },
                ]
            },
            {
                img: '/images/male.png',
                name: 'test2',
                dec: 'test test test test test2',
                prc: '20',
                time: [
                    {
                        time: '8:30',
                    },
                    {
                        time: '9:30',
                    },
                    {
                        time: '10:30',
                    },
                    {
                        time: '11:30',
                    },
                    {
                        time: '12:30',
                    },
                    {
                        time: '13:30',
                    },
                    {
                        time: '14:30',
                    },
                ]
            },
            {
                img: '/images/male.png',
                name: 'test3',
                dec: 'test test test test test3',
                prc: '20',
                time: [
                    {
                        time: '8:30',
                    },
                    {
                        time: '9:30',
                    },
                    {
                        time: '10:30',
                    },
                    {
                        time: '11:30',
                    },
                    {
                        time: '12:30',
                    },
                    {
                        time: '13:30',
                    },
                    {
                        time: '14:30',
                    },
                ]
            },
            {
                img: '/images/male.png',
                name: 'test4',
                dec: 'test test test test test4',
                prc: '20',
                time: [
                    {
                        time: '8:30',
                    },
                    {
                        time: '9:30',
                    },
                    {
                        time: '10:30',
                    },
                    {
                        time: '11:30',
                    },
                    {
                        time: '12:30',
                    },
                    {
                        time: '13:30',
                    },
                    {
                        time: '14:30',
                    },
                ]
            },
        ],
        isOpen: { 0: true },
        currentday: 0

        // headers: [
        //     // { key: 'values.name', type: 'TextInput', col: '6', information: { label: '{{lang}}First Name', placeholder: '{{lang}}Write the name', required: true } },
        //     // { key: 'values.family', type: 'TextInput', col: '6', information: { label: '{{lang}}LastName', placeholder: '{{lang}}Write the name', required: true } },
        //     // { key: 'values.email', type: 'TextInput', col: '6', information: { label: '{{lang}}Email', placeholder: '{{lang}}ExampleMail@Email.com', required: true } },
        //     // { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone', placeholder: '{{lang}}Phone', required: true }, showMain: false },
        //     // { key: 'values.message', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Message', placeholder: '{{lang}}Write your Message.....', required: false }, showMain: false },
        //     // { key: 'selectimage', type: 'ImageInput', col: '6', information: { label: 'Insert Image', required: false }, showMain: false },
        //     // { key: 'selectimage', type: 'ImageInput', col: '6', information: { required: false }, showMain: false },
        //     // { key: 'selectimage', type: 'ImageInput', col: '6', information: { required: false }, showMain: false },
        //     // { key: 'selectimage', type: 'ImageInput', col: '6', information: { required: false }, showMain: false },

        //     // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Name of the product', placeholder: '{{lang}}Writ the name', required: true } },


        //     {
        //         key: 'genders',
        //         type: 'MultiSelectInput',
        //         col: '12',
        //         information: {
        //             label: '{{lang}}Genders',
        //             placeholder: '{{lang}}select genders',
        //             type: 'local',
        //             items: [
        //                 { title: "men", value: 'men' },
        //                 { title: "women", value: 'women' },
        //                 { title: "boys", value: 'boys' },
        //                 { title: "girls", value: 'girls' },
        //                 { title: "babies", value: 'babies' }
        //             ],
        //             required: true

        //         },
        //         showMain: true,
        //     },

        //     { type: 'MultiLevelInput', key: 'categories', col: '12', information: { label: 'Category', type: 'api', startPoint: null, root: null, isSearchable: true, reference: 'parent', fields: { value: '_id', title: 'name', image: 'image', parent: 'parent' }, address: 'getAllCategory', filter: {}, body: { sort: { name: 1 } }, required: true }, showMain: false },





        //     { key: 'cover', type: 'ImageInput', col: '12', information: { label: '{{lang}}Cover Image', required: false, single: true, cropper: true, ratio: '1:1' }, showMain: false },
        //     { key: 'images', type: 'ImageInput', col: '12', information: { label: '{{lang}}Other images', required: false }, showMain: false },







        //     // { key: 'phone', type: 'TextInput', col: '6', information: { label: '{{lang}}Phone', placeholder: '{{lang}}Phone', required: true }, showMain: false },
        // ],
    }
    // handleStep = () => {
    //     this.props.changePage('secondStep', 1)
    // }
    nextPage = (index) => {
        let data = this.state.book
        console.log(data)
        if (data) {
            this.props.setData(data, (result, err) => {
                this.props.changePage('secondStep', 1)
            })
        }
    }
    changeCollapse = (index) => {
        let isOpen = this.state.isOpen
        isOpen[index] = !isOpen[index]

        console.log('isOpen', isOpen)

        // console.log('isOpen[index]', isOpen[index])
        this.setState({ isOpen })
        console.log('!isOpen[index]', this.state.isOpen)
        // console.log('this.setState({isOpen})', this.setState({ isOpen }))
    }
    changeIndex = (index) => {
        this.setState({ currentday: index })
    }
    render() {
        return (
            <div className='flexcc'>
                <div className='w-100 ' >
                    <div className='flexcb'>
                        <div className='w-50 flexcb' style={{ alignItems: 'center', background: '#F6F7F8', padding: '10px 17px', borderRadius: 15 }}>
                            <div>
                                <p>
                                    icon search
                                </p>
                            </div>
                            <div style={{ flex: 1, direction: 'rtl' }}>
                                <input placeholder='Search' className='w-100' style={{ outline: 0, border: 0, background: 'transparent' }} />
                            </div>
                            {/* <img src='/im' /> */}
                        </div>
                        <div><p>انتخاب سینما و سانس</p></div>
                    </div>
                    <div style={{ marginTop: 15, display: 'flex' }}>

                        {this.state.today.map((item, index) => {
                            return (
                                <button onClick={() => this.changeIndex(index)}>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', alignItems: 'center', marginRight: '20px' }}>
                                        <div style={{ background: this.state.currentday == index ? '#F6F7F8' : 'transparent', padding: '5px 15px', borderRadius: 50, flex: 1, marginBottom: 11 }}>
                                            <p style={{ textAlign: 'center' }}>{item.day}</p>
                                        </div>
                                        <div>
                                            <p style={{ textAlign: 'center', fontSize: 10, color: '#A5A5A5' }}>{item.cot}</p>
                                        </div>
                                    </div>
                                </button>
                            )
                        })}
                    </div>
                    <div style={{ marginTop: 15, }} >

                        {this.state.book.map((item, index) => {
                            return (
                                <div>
                                    <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', width: '100%', alignItems: 'center', marginRight: '20px', marginBottom: 15 }}>
                                            <div style={{ width: '55px', height: '55px' }}>
                                                <img className='w-100' style={{ borderRadius: 15, }} src={item.img} />
                                            </div>
                                            <div style={{ marginLeft: 15 }}>
                                                <div style={{ marginBottom: 3 }}>
                                                    <p style={{ fontWeight: '500', fontSize: 12 }}>{item.name}</p>
                                                </div>
                                                <div style={{ marginBottom: 3 }}>
                                                    <p style={{ color: '#000', fontWeight: '400', fontSize: 12 }}>{item.dec}</p>
                                                </div>
                                                <div style={{ display: 'flex', alignItems: 'center', width: '35%', marginBottom: 11 }}>
                                                    <p style={{ textAlign: 'start', color: '#000', fontSize: 11, fontWeight: 400 }}>{item.prc}</p><p style={{ marginLeft: 4, color: '#000', fontSize: 11, fontWeight: 400 }}>تومان</p>
                                                </div>
                                            </div>

                                        </div>

                                        <div>
                                            {/* <button className={styles.dropdown} onClick={()=>this.changeCollapse(index)} style={{background:'none',border:'none', }}> */}
                                            <button onClick={() => this.changeCollapse(index)} style={{ background: 'none', border: 'none', }}>
                                                {this.state.isOpen[index] == true ? (

                                                    <img width={20} src='/images/icons/minus.png' />
                                                ) : (

                                                    <img width={20} src='/images/icons/plus.png' />
                                                )}
                                                {/* <p style={{color:'#fff'}}><Texts question={text.question}/></p> */}
                                            </button>
                                        </div>
                                    </div>
                                    <div className='w-100 h-100' style={{ marginBottom: 15 }}>

                                        <Collapsible open={this.state.isOpen[index]}  >
                                            <div className='w-100 h-100' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', }}>
                                                {item.time.map((data, index) => {
                                                    return (

                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: 9, marginRight: 7, }}>

                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#F6F7F8', padding: '5px 15px', width: '100%', borderRadius: '7px 7px 0 0' }}>
                                                                <div>
                                                                    <p style={{ fontSize: 12, color: '#A5A5A5' }}>{data.time} سانس</p>
                                                                </div>
                                                            </div>
                                                            <button onClick={() => this.nextPage(index)} className='flexcc w-100' style={{ background: '#ccc', borderRadius: '0 0 7px 7px', padding: '3px 0px', }}>
                                                                <p style={{ fontSize: 12, textAlign: 'center', color: '#252525' }}>
                                                                    رزرو
                                                                </p>
                                                            </button>
                                                        </div>

                                                    )
                                                })}
                                            </div>
                                        </Collapsible>

                                    </div>
                                </div>
                            )
                        })}

                        <button onClick={() => this.nextPage()}>FirstStep</button>
                        {/* <FormViewer ref={el => this.form = el} initData={this.props.initData} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} /> */}
                        {/* <LoaderButton
                            onClick={this.nextPage}
                            // isLoading={this.state.isLoading}
                            // text={translate('send')}
                            text='Next'
                            type={"Oval"}
                            className="mt-4 mb-3"
                            buttonStyle={{ outline: 'none', backgroundColor: '#252525', cursor: 'pointer', padding: '10px 50px', borderRadius: 50, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                            width={40}
                            height={40}
                            color={'#fff'}
                        /> */}
                    </div>
                </div>
            </div>
        )
    }
}
